import { c as _c } from "react/compiler-runtime";
import { ComponentSharedSeo } from "@lib/generated/graphql";
import { LanguageAlternate } from "@lib/routing";
import { NextSeo } from "next-seo";
import { OpenGraph } from "next-seo/lib/types";
const noIndexRegex = /noindex/;
const noFollowRegex = /nofollow/;
const SEO = t0 => {
  const $ = _c(12);
  const {
    seoData,
    openGraph,
    languageAlternates
  } = t0;
  let t1;
  if ($[0] !== seoData.metaRobots) {
    t1 = seoData.metaRobots ? noFollowRegex.test(seoData.metaRobots) : false;
    $[0] = seoData.metaRobots;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const nofollow = t1;
  let t2;
  if ($[2] !== seoData.metaRobots) {
    t2 = seoData.metaRobots ? noIndexRegex.test(seoData.metaRobots) : false;
    $[2] = seoData.metaRobots;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const noindex = t2;
  const t3 = seoData.canonicalURL || "";
  let t4;
  if ($[4] !== languageAlternates || $[5] !== nofollow || $[6] !== noindex || $[7] !== openGraph || $[8] !== seoData.metaDescription || $[9] !== seoData.metaTitle || $[10] !== t3) {
    t4 = <NextSeo nofollow={nofollow} noindex={noindex} title={seoData.metaTitle} description={seoData.metaDescription} canonical={t3} openGraph={openGraph} languageAlternates={languageAlternates} />;
    $[4] = languageAlternates;
    $[5] = nofollow;
    $[6] = noindex;
    $[7] = openGraph;
    $[8] = seoData.metaDescription;
    $[9] = seoData.metaTitle;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default SEO;